import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/filter'
import ElementUI from 'element-ui';
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
